import React, { useEffect, useState } from "react";
import { Card, Container, Spinner, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import styles from "./SubjectList.module.css";
import { connect } from "react-redux";
import { AiFillEdit } from "react-icons/ai";
import { BsCheck, BsFileEarmarkPlus, BsTrash, BsX } from "react-icons/bs";
import { useModals } from "@mantine/modals";
import { Badge, Button, Input, Text } from "@mantine/core";
import { toast } from "react-toastify";
import { getGradeList } from "../../actions/Grade.action";
import {
  deleteSubject,
  updateSubjectSerial,
} from "../../actions/Subject.action";
import { sortSubject } from "../../utils/sortSubject";

const SubjectList = ({
  list,
  getGradeList,
  deleteSubject,
  updateSubjectSerial,
}) => {
  const [rawList, setRawList] = useState(list === null ? [] : list);
  const [changedList, setChangedList] = useState(null);

  const modals = useModals();

  useEffect(() => {
    if (list === null) {
      getGradeList();
    }
    if (list !== null) {
      setRawList(list);
    }
  }, [list]);

  const handleChange = (id, serial, gradeId) => {
    setChangedList({ id, serial });
    setRawList((prev) => {
      let newList = [...list];
      newList = newList.map((g) => {
        if (g.id === gradeId) {
          g.subjects = g.subjects.map((s) => {
            if (s.id === id) {
              s.serial = serial;
            }
            return s;
          });
        }
        return g;
      });
      return newList;
    });
  };

  const saveChanged = async () => {
    await updateSubjectSerial(changedList.id, changedList.serial);
    setChangedList(null);
  };

  const deleteHandeler = (id) =>
    modals.openConfirmModal({
      title: "Delete this subject",
      centered: true,
      children: (
        <Text size="md">
          Are you sure you want to delete this subject? This action is
          destructive and you can not undo it.
        </Text>
      ),
      labels: { confirm: "Delete Subject", cancel: "No don't delete it" },
      confirmProps: { color: "red" },
      onCancel: () => {},
      onConfirm: () => confirmHandeler(id),
    });

  const confirmHandeler = async (id) => {
    let check = await deleteSubject(id);
    if (check === true) {
      toast.success("Subject deleted successfully");
    } else {
      toast.error("Something went wrong");
    }
  };

  return (
    <Container className="pb-4">
      <div className="d-flex justify-content-end align-items-center pb-3 ">
        <div className="text-right">
          <Link to="/admin/subject/add" className={styles.add}>
            <BsFileEarmarkPlus />
          </Link>
        </div>
      </div>
      <Card className="crd p-md-4 pb-md-0 p-2">
        <Card.Body>
          {rawList === null ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: 600 }}
            >
              <Spinner variant="dark" animation="grow" />
            </div>
          ) : rawList.length === 0 ? (
            <span className="text-center fs-4 d-block pb-3">
              No Subject Found
            </span>
          ) : (
            <>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Class</th>
                    <th>Subject</th>

                    <th colSpan={2}>
                      <div className="d-flex justify-content-center align-items-center">
                        Actions
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rawList !== null &&
                    rawList.map((gradeItem, i) => (
                      <tr key={gradeItem.id}>
                        <td>{i + 1}</td>
                        <td>{gradeItem.name} </td>

                        <td colSpan={3}>
                          <Table borderless responsive className="p-0 m-0">
                            <tbody>
                              {sortSubject(gradeItem.subjects).map((sft, i) => (
                                <tr
                                  key={sft.id}
                                  className={
                                    i !== gradeItem.subjects.length - 1
                                      ? "border-bottom"
                                      : ""
                                  }
                                >
                                  <td>
                                    {sft.name} <br />
                                    {sft.subjectMonths.map((mon) => (
                                      <Badge
                                        variant="filled"
                                        size="xs"
                                        key={mon.id}
                                        mr={2}
                                      >
                                        {mon.name}
                                      </Badge>
                                    ))}
                                  </td>
                                  <td className="">
                                    <Input
                                      value={sft.serial}
                                      type="number"
                                      onChange={(e) =>
                                        handleChange(
                                          sft.id,
                                          e.target.value || "",
                                          gradeItem.id
                                        )
                                      }
                                    />
                                    {changedList !== null &&
                                    changedList.id === sft.id ? (
                                      <>
                                        <Button
                                          size="xs"
                                          onClick={() => {
                                            setChangedList(null);
                                            saveChanged();
                                          }}
                                          color="green"
                                          m={2}
                                        >
                                          <BsCheck />
                                        </Button>
                                        <Button
                                          m={2}
                                          color="red"
                                          size="xs"
                                          onClick={() => {
                                            setChangedList(null);
                                          }}
                                        >
                                          <BsX />
                                        </Button>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </td>
                                  <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                      <Link
                                        to={`/admin/subject/${sft.id}/edit`}
                                        className={` fw-bold  me-4 ${styles.link}`}
                                      >
                                        <AiFillEdit />
                                      </Link>{" "}
                                      <span
                                        onClick={() => deleteHandeler(sft.id)}
                                        className={`fw-bold ${styles.link}`}
                                      >
                                        <BsTrash />
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  list: state.grade.grade,
});

export default connect(mapStateToProps, {
  getGradeList,
  deleteSubject,
  updateSubjectSerial,
})(SubjectList);
